import { Schema } from '../../schema'
import { UserWorkspaceAttributeDTO } from '../../types'
import { Variables } from './api'

export const mapper = (data: Schema): Variables => {
  const { email, userWorkspaceAttributes } = data

  return {
    email,
    userWorkspaceAttributes: userWorkspaceAttributes.map(
      ({ role, workspaceId }): UserWorkspaceAttributeDTO => ({
        role,
        workspaceId: workspaceId.value,
      }),
    ),
  }
}
